// App.js
import React from "react";
import { AppShell } from "@1823-partners/core";
import Dashboard from "./components/Dashboard";
import api from "./api";

export default function App() {
  return (
    <AppShell appName="surveillance" title="Surveillance" api={api}>
      {({ userInfo }) => <Dashboard userId={userInfo?.userDetails} />}
    </AppShell>
  );
}
